import { render, staticRenderFns } from "./reftable-item-selector.vue?vue&type=template&id=6c9c25c0&lang=pug&"
import script from "./reftable-item-selector.vue?vue&type=script&lang=ts&"
export * from "./reftable-item-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports